import { useCallback, useEffect, useState } from "react";
import { getJustificacionPendientePerforadora } from "../../services/justificacion";

export function useGetJustificacionPendientePerforadora(idAreaOperacion, inicioMes, finMes) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      if (idAreaOperacion !== 29) {
        setData([]);
        return;
      }

      const data = await getJustificacionPendientePerforadora(idAreaOperacion, inicioMes, finMes);

      if (data.status === "success") {
        setData(Array.isArray(data.data) ? data.data : []);
      } else {
        setError(data.message);
        setData([]);
      }
    } catch (err) {
      setError("Ha ocurrido un error al intentar obtener los datos");
      setData([]); 
    } finally {
      setLoading(false);
    }
  }, [idAreaOperacion, inicioMes, finMes]);

  useEffect(() => {
    fetchData();
  }, [idAreaOperacion, inicioMes, finMes, fetchData]);

  return { 
    justificacionPendiente: data, 
    loadingJustificacionPendiente: loading, 
    errorJustificacionPendiente: error 
  };
}
